import React, {useCallback, useRef, useState} from 'react'
import {AutoComplete} from 'antd'

import {postcodesService} from 'services/postcodes'
import requestHandler from 'utils/requestHandler'
import BAutocomplete from 'components/Form/Fields/BAutocomplete'
import BButton from 'components/Form/Fields/BButton'

const debounceDelay = 500

const renderItem = ({query, result}) => ({
  value: query,
  label: (
    <div title={`${result.admin_district}, ${result.admin_ward}`}>
      <b>{result.postcode}</b> <i>({result.admin_district}, {result.admin_ward})</i>
    </div>
  ),
})


const PostcodeAutoComplete = ({setSelectedAddressParser, inputValue, setInputValue, t}) => {
  const [options, setOptions] = useState(undefined)

  const debounce = useRef(undefined)

  const onSelect = useCallback(e => {
    setInputValue(e)
  }, [setInputValue])

  const lookupDetail = useCallback((postcodes, latestDebounceId) => {
    if (postcodes) {
      requestHandler(() => postcodesService.postcodes(postcodes), 'json')
        .then(r => {
          if (r.status < 400) {
            if (latestDebounceId === debounce.current) {
              setOptions(r.result.map(renderItem))
            }
          } else {
            setOptions(null)
          }
        })
    } else {
      setOptions([{value: '', label: t('No results')}])
    }
  }, [t])

  const onSearch = useCallback(e => {
    setOptions(undefined)
    clearTimeout(debounce.current)

    if (e?.length > 1) {
      debounce.current = setTimeout(() => {
        requestHandler(() => postcodesService.autocomplete(e), 'json')
          .then(r => {
            if (r.status < 400) lookupDetail(r.result, debounce.current)
            else setOptions(null)
          })
      }, debounceDelay)
    }
  }, [lookupDetail])

  return (
    <>
      <BAutocomplete white label={t('YOUR DELIVERY POSTCODE')}>
        <AutoComplete
          placeholder={t('Type postcode')}
          onSelect={onSelect}
          onSearch={onSearch}
          options={options}
        />
      </BAutocomplete>

      <BButton onClick={_ => setSelectedAddressParser(inputValue)}>{t('SAVE ADDRESS')}</BButton>
    </>
  )
}

export default PostcodeAutoComplete
